import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircledIcon, CircleIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons';
import './Editor.css';
const icons = {
    error: _jsx(CircleIcon, {}),
    warning: _jsx(ExclamationTriangleIcon, {}),
    success: _jsx(CheckCircledIcon, {}),
};
export function StatusBar({ message, type }) {
    if (!message || message.trim() === '')
        return null;
    return (_jsxs("div", { className: "status-bar", children: [type && icons[type], _jsx("span", { children: message })] }));
}
